/**
 * Nexus — settings page.
 *
 * Route: /prioritization/settings/nexus-agent
 *
 * On the agent template since migration 941 (SPEC-custom-agent-template.md
 * T2): the template's common settings page with the propose_relationship
 * panel; custom agents made on the same behavior get the same page. Its old
 * settings table (nexus_agent_config) is retired — DEP-038.
 */

import { TemplateAgentSettings } from '../../../components/agents/TemplateAgentSettings';
import { NEXUS } from '../../../lib/ai/agentDefinitions';

export default function NexusAgent() {
  return <TemplateAgentSettings def={NEXUS} />;
}
